import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../common.service';
@Component({
  selector: 'app-viewagegroup',
  templateUrl: './viewagegroup.component.html',
  styleUrls: ['./viewagegroup.component.css']
})
export class ViewagegroupComponent implements OnInit {
  returnUrl="/dashboard/speciesmanagement";
  getspeciesviewApi: string;
  getval:any;
  arrayval:any=[];
  constructor(private router: Router,private commonService: CommonService) { }

  async ngOnInit(){
    let speaciesId = sessionStorage.getItem('speciesId');
    this.getspeciesviewApi= "/species/"+ speaciesId;
    (await this.commonService.getApi(this.getspeciesviewApi)).subscribe(
      res => {
        this.arrayval=res.data.age_group.map((ele)=>{
          var splitedrange= ele.tnag_time_range.split('-');
          var lowerlimit=splitedrange[0];
          var upperlimit=splitedrange[1];
           return {"tnag_name":ele.tnag_name,"lowerlimit":lowerlimit,"upperlimit":upperlimit,"tnag_id":ele.tnag_id}
         })
      })
    }
  speciesmanagement(){
    this.router.navigate([this.returnUrl]);
  }
  backnavigate(){
    this.router.navigate([this.returnUrl]);
  }
  }
